import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeColorService {
  private document = inject<Document>(DOCUMENT);

  resolve(variableName: string): string {
    const styles = this.document.defaultView?.getComputedStyle(this.document.documentElement);
    const visitedVariables = new Set<string>();
    let currentVariable = variableName;

    while (styles && !visitedVariables.has(currentVariable)) {
      visitedVariables.add(currentVariable);
      const value = styles.getPropertyValue(currentVariable).trim();

      if (!value) {
        return 'currentColor';
      }

      const variableReference = value.match(/^var\(\s*(--[\w-]+)\s*\)$/);
      if (!variableReference) {
        return value.startsWith('rgb(') ? value : `rgb(${value})`;
      }

      currentVariable = variableReference[1];
    }

    return 'currentColor';
  }
}
